export const environment = {
  production: false,
  defaultauth: 'local',
  // apiUrl: 'https://devesignapi.ihostmyform.com/api',
  apiUrl: 'https://api-saas-esign.avsstech.in/api',
  // apiUrl: 'http://192.168.1.132:3000/api',
  avsLogger: {
    project: 'avss-esign-backend',
    key: 'dev-secret-key-123',
    url: 'https://devlog.ihostmyform.com'
  },
  firebaseConfig: {
    apiKey: '',
    authDomain: '',
    databaseURL: '',
    projectId: '',
    storageBucket: '',
    messagingSenderId: '',
    appId: '',
    measurementId: ''
  }
};